import { ReactElement } from 'react';
import type { Honbu } from '../types';
import { useCallSettings } from '../hooks/useCallSettings';
import AdvertisementSection from './AdvertisementSection';
import { EmptyHint } from './styles';

interface Props {
  honbu: Honbu;
}

const AdvertisementSections = ({ honbu }: Props): ReactElement => {
  const settings = useCallSettings(honbu);
  // 取得は成功したが対象本部の設定が1件もないケースを、ロード失敗と区別できるよう明示する。
  if (settings.length === 0) {
    return <EmptyHint>表示できる即架電設定がありません</EmptyHint>;
  }
  return (
    <>
      {settings.map(setting => (
        <AdvertisementSection key={setting.id} setting={setting} />
      ))}
    </>
  );
};

export default AdvertisementSections;
